import { Component, EventEmitter, HostListener, Inject, Input, OnDestroy, OnInit, Optional, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { GridColumnModel, GridComponent, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CommonService } from '../../../shared/services/common.service';
import { DataManager, ODataV4Adaptor } from '@syncfusion/ej2-data';
import { updateFilterIcon } from '../../../shared/models/utils/grid-functions';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { environment } from '../../../../environments/environment';
import { LeadsPopupComponent } from '../../leads/leads-popup/leads-popup.component';
import { defaultProspectData } from '../../business-partners/model/prospects-data';
import { ProductCatalogPopupComponent } from '../../product-catalog/product-catalog-popup/product-catalog-popup.component';
import { ProposalPopupComponent } from '../proposal-popup/proposal-popup.component';
import { ProposalService } from '../proposal.service';
import { OnholdDetailsPopupComponent } from '../proposal-popup/onhold-details-popup/onhold-details-popup.component';
import { ModuleNames, tabsModel } from '../../../shared/models/app.model';
import { SharedService } from 'projects/shared/src/public-api';
import { RevisionDetailsPopupComponent } from '../proposal-popup/revision-details-popup/revision-details-popup.component';
import { SalesOrderPopupComponent } from '../../sales-order/sales-order-popup/sales-order-popup.component';
import { DocFilesPopupComponent } from '../../../shared/components/proposal-doc-files-popup/doc-files-popup.component';
import { ProspectsPopupComponent } from '../../business-partners/prospects-popup/prospects-popup.component';
import { OpportunitiesService } from '../../opportunities/opportunities.service';
import { SetupAccountPopupComponent } from '../../accounts/setup-account-popup/setup-account-popup.component';

@Component({
    selector: 'app-proposal-grid',
    templateUrl: './proposal-grid.component.html',
    styleUrl: './proposal-grid.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProposalGridComponent implements OnInit, OnDestroy{

  dataSource: any = [];
  columns!: GridColumnModel[]
  grid!: GridComponent;
  searchSettings?: SearchSettingsModel;
  showLoader = true;
  gridHeight = window.innerHeight - 400;
  obsoleteItemsExists: boolean = false
  private subscription?: Subscription;
  rolePermissions: any = {}
  @Output() refreshOpportunity = new EventEmitter();
  @Output() openDistributorPopupFromProposal = new EventEmitter()
  private initialNeedsAssessmentSnapshot: Array<{
    id: number;
    statusValue: string;
    isDeleted: boolean;
  }> = [];
  sortOptions = {
    columns: [
        { field: 'isActive', direction: 'Descending' }
    ]
  };

  // prospectData = defaultProspectData;
  prospectData: any = {};
  showProspectsPopup = false

  @Input() opportunityForm;
  @Input() status: string;
  @Input() oppId;
  @Input() canAddProposal;
  @Input() canEditDistributor = false;

  @ViewChild('columnChooser') columnChooser: any;
  @ViewChild('addLeads') addLeads: any;
  @ViewChild('obsoleteItemToolbar') obsoleteItemToolbar: any;
  
  destroy$: Subject<any> = new Subject();

  @ViewChild('proposalGrid') set gridComponent(gridComponent: GridComponent) {
    if (gridComponent) {
      this.grid = gridComponent;
    }
  }

  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private authService: AuthService,
    private proposalService: ProposalService,
    private opportunitiesService: OpportunitiesService,
    private http: HttpClient,
    @Optional() public dialogRef: MatDialogRef<ProposalGridComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private sharedService: SharedService
  ) {
    // this.dataSource = new DataManager({

    //   url: `${environment.saleApiUrl}odata/Proposal`,
    //   adaptor: new ODataV4Adaptor(),
    //   headers: [{'Authorization': `Bearer ${authService.getToken()}`}]
    // });

  }
  hasConverted = false

  loadData() {
    this.showLoader = true
    this.proposalService.getProposalByOppId(this.oppId).subscribe({
      next: (response: any) => {
        this.dataSource = response.result
        this.hasConverted = this.dataSource.some(item => item.statusValue === 'propConverted');
        this.setToolbar()
        this.grid.refresh()
        this.showLoader = false
      },
      error: (error: any) => {
        this.showLoader = false
      }
    });
  }

  ngOnInit(): void {
  this.loadData()
  this.captureInitialNeedsAssessmentSnapshot()
  this.getRolePermission()
  this.getColumns()
  this.searchSettings = {
      fields: [
        'opportunityId',
        'proposalId',
        'customer',
        'customerType',
        'createdDate',
        'itemCount',
        'totalAmount',
        'revision',
        'revisionDate',
        'submissionDate',
        'statusText',
      ]
    };
  }

  onBPIdClick(soldToBP) {
    this.prospectData.soldToExtId = soldToBP
    this.showProspectsPopup = true
  }
  captureInitialNeedsAssessmentSnapshot(): void {
    if (!this.oppId) return;
    this.opportunitiesService.getOpportunityById(this.oppId).subscribe({
      next: (res: any) => {
        const salesProcess = res?.result?.salesProcess || [];
        this.initialNeedsAssessmentSnapshot = this.buildNeedsAssessmentSnapshot(salesProcess);
      },
      error: () => {
        this.initialNeedsAssessmentSnapshot = [];
      }
    });
  }
  buildNeedsAssessmentSnapshot(list: any[] = []) {
    const needsAssessment = (list || []).find(
      (a: any) => a.title && a.title.toLowerCase() === 'needs assessment' && !a.isDeleted
    );
    if (!needsAssessment) {
      return [];
    }
    const relevantItems = (list || []).filter(
      (a: any) => a.id === needsAssessment.id || a.parentId === needsAssessment.id
    );
    return relevantItems
      .map((item: any) => ({
        id: item.id,
        statusValue: item.statusValue ?? '',
        isDeleted: !!item.isDeleted,
      }))
      .sort((a, b) => a.id - b.id);
  }
  hasNeedsAssessmentChangedSinceOpen(): boolean {
    const currentSalesProcess = this.opportunityForm?.get('salesProcess')?.value || [];
    const currentSnapshot = this.buildNeedsAssessmentSnapshot(currentSalesProcess);
    return JSON.stringify(this.initialNeedsAssessmentSnapshot) !== JSON.stringify(currentSnapshot);
  }
  getColumns() {
    const commands = [];
    if (this.rolePermissions['proposalGrid_revise']?.visible ?? true) {
      commands.push({ title: 'Revise', buttonOption: { iconCss: 'fas fa-redo', cssClass: 'e-flat revise-item' } });
    }
    if (this.rolePermissions['proposalGrid_approve']?.visible ?? true) {
      commands.push({ title: 'Approve', buttonOption: { iconCss: 'fas fa-check', cssClass: 'e-flat approve-item green-icon' } });
    }
    if (this.rolePermissions['proposalGrid_reject']?.visible ?? true) {
      commands.push({ title: 'Reject', buttonOption: { iconCss: 'fas fa-times', cssClass: 'e-flat reject-item red-icon' } });
    }
    // if (this.rolePermissions['proposalGrid_printProposal']?.visible ?? true) {
    //   commands.push({ title: 'Print proposal', buttonOption: { iconCss: 'fas fa-print', cssClass: 'e-flat print-item' } });
    // }
    if (this.rolePermissions['proposalGrid_markActive']?.visible ?? true) {
      commands.push({ title: 'Mark active', buttonOption: { iconCss: 'fas fa-circle-check', cssClass: 'e-flat markActive-item' } });
    }
    if (this.rolePermissions['proposalGrid_convert']?.visible ?? true) {
      commands.push({ title: 'Convert', buttonOption: { iconCss: 'fas fa-exchange', cssClass: 'e-flat convert-item' } });
    }
    if (this.rolePermissions['proposalGrid_onHold']?.visible ?? true) {
      commands.push({ title: 'On Hold', buttonOption: { iconCss: 'fas fa-pause', cssClass: 'e-flat onHold-item' } });
    }
    if (this.rolePermissions['proposalGrid_attachments']?.visible ?? true) {
      commands.push({ title: 'Attachments', buttonOption: { iconCss: 'fas fa-file-upload', cssClass: 'e-flat attachments-items' } });
    }
    if (this.rolePermissions['proposalGrid_comments']?.visible ?? true) {
      commands.push({ title: 'Comments', buttonOption: { iconCss: 'fas fa-comment', cssClass: 'e-flat comments-items' } });
    }
    // if (this.rolePermissions['proposalGrid_links']?.visible ?? true) {
      commands.push({ title: 'Links', buttonOption: { iconCss: 'fas fa-link', cssClass: 'e-flat linked-items' } });
    // }
    // if (this.rolePermissions['proposalGrid_history']?.visible ?? true) {
      commands.push({ title: 'History', buttonOption: { iconCss: 'fas fa-history history', cssClass: 'e-flat history-items' } });
    // }

    this.columns = [
      { field: 'isActive', headerText: '', type: 'boolean', allowSorting: true, allowEditing: false, showInColumnChooser: false, visible: false },
      { field: 'proposalId', headerText: "Proposal ID", allowEditing: false, textAlign: 'Left', allowFiltering: true, allowSorting: true, width: 200, isPrimaryKey: true, showInColumnChooser: true },
      { field: 'opportunityId', headerText: "Opportunity ID", allowEditing: false, textAlign: 'Left', allowFiltering: true, visible: true, allowSorting: true, width: 200, showInColumnChooser: true },
      { field: 'customer', headerText: 'Customer', allowEditing: false, textAlign: 'Left', allowFiltering: true, visible: true, allowSorting: true, width: 200, showInColumnChooser: true },
      { field: 'customerType', headerText: 'Customer Type', type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: false, showInColumnChooser: true },
      { field: 'assignedResourceName', headerText: 'Assigned Resource', type: 'string', filter: { type: 'Excel' },  allowEditing: false, textAlign: 'Left', width: 250, visible: true, showInColumnChooser: true },
      { field: 'salesRep', headerText: 'Primary Sales Rep', type: 'string', filter: { type: 'Excel' },  allowEditing: false, textAlign: 'Left', width: 250, visible: true, showInColumnChooser: true },
      { field: 'salesLeadId', headerText: 'Lead ID', type: 'String', allowEditing: false, width: 140, textAlign: 'Left', visible: false, showInColumnChooser: true },
      { field: 'leadSource', headerText: 'Lead Source', type: 'String', allowEditing: false, width: 160, textAlign: 'Left', visible: false, showInColumnChooser: true },
      { field: 'itemCount', headerText: 'No. of items', type: 'String', allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
      { field: 'totalAmount', headerText: 'Total Amount', type: 'number', format: 'n2', allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
      { field: 'salesType', headerText: 'Sales Type', type: 'String', allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
      { field: 'accountName', headerText: 'Distributor', type: 'String', allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
      { field: 'createdDate', headerText: 'Created Date', type: 'date', textAlign: 'Left',  format: { type: 'date', format: 'd MMM, y' }, width: 160, showInColumnChooser: true },
      { field: 'submissionDate', headerText: 'Submitted Date', type: 'date', format: { type: 'date', format: 'd MMM, y' }, allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: 'revision', headerText: 'Revision', filter: { type: 'Menu' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: 'revisionDate', headerText: 'Revision Date', type: 'date', textAlign: 'Left',  format: { type: 'date', format: 'd MMM, y' }, width: 160, showInColumnChooser: true },
      { field: 'statusText', headerText: 'Status', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      {
        field: 'Actions', headerText: 'Actions', width: 320, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Right', allowReordering: false,
        commands: commands
      }
    ];
  }

  openDistributorPopup(data: any) {
    if (data?.accountId) {
      this.openSetupAccountPopup(data.accountId);
      return;
    }
    const accountValue = data?.accountValue;
    if (!accountValue) {
      return;
    }
    this.showLoader = true;
    this.http.get(`${environment.masterApiURL}odata/getAllChannelAccounts?$filter=accountValue eq '${accountValue}'&$top=1`)
      .subscribe({
        next: (res: any) => {
          this.showLoader = false;
          const accountId = res?.value?.[0]?.accountId || res?.result?.[0]?.accountId;
          if (accountId) {
            this.openSetupAccountPopup(accountId);
          } else {
            this.commonService.showNotification('warning', 'Unable to open Distributor details.');
          }
        },
        error: () => {
          this.showLoader = false;
          this.commonService.showNotification('warning', 'Unable to open Distributor details.');
        }
      });
  }

  openSetupAccountPopup(id: string = '') {
    this.dialog.open(SetupAccountPopupComponent, {
      backdropClass: 'no-backdrop',
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      data: { id },
    });
  }

  openLeadsPopup(id: string = null) {
      const dialog = this.dialog.open(LeadsPopupComponent, {
        backdropClass: 'no-backdrop',
        disableClose: true,
        maxWidth: '100vw',
        maxHeight: '100vh',
        width: '100%',
        height: '100%',
        enterAnimationDuration: '0',
        exitAnimationDuration: '0',
        autoFocus: false,
        data: {
          id: id,
          isMaximized: true,
        }
      });
      dialog.afterClosed().subscribe(result => {
        // if (result) {
          // this.loadData()
        // }
    });
  }

  openProspectPopup(customerId: string) {
    this.prospectData = { soldToExtId: customerId };
    this.showProspectsPopup = true;
    const dialogRef = this.dialog.open(ProspectsPopupComponent, {
      backdropClass: 'no-backdrop',
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      data: {
        showProspectsPopup: this.showProspectsPopup,
        prospectData: this.prospectData,
        id: this.prospectData.soldToExtId,
        tab: tabsModel.details,
        isMaximized: true,
        // isReadOnly: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.grid.refresh();
    });
  }

  setToolbar() {
    this.grid.toolbar = [
      { id: 'column-chooser', template: this.columnChooser, tooltipText: 'Show/Hide Columns' },
      // { id: 'refresh', align: 'Right', prefixIcon: 'fas fa-redo-alt', cssClass: '', tooltipText: 'Refresh' },
      'Search',
      { text: '', id: 'clear-filter', align: 'Right', prefixIcon: 'fas fa-filter', cssClass: `grid-filter-icon`, tooltipText: 'Clear all Filters' },
      // { id: 'add', align: 'Left', template: this.addLeads, prefixIcon: 'fas fa-add', cssClass: '', tooltipText: 'Add' }
    ];
    const index = this.grid.toolbar.findIndex((item: any) => item.id === 'column-chooser');
    const status = this.opportunityForm?.value?.statusValue;
    const isSalesLost = status === 'oppSaleLost' || status === 'oppSalesLost';
    // Sales Lost: show + only when backend canEditDistributor is true (proposal rejected, no SO).
    const statusAllowsAdd = ['oppProposal', 'oppInProgress', 'oppDelayed'].includes(status)
      || (isSalesLost && this.canEditDistributor);
    if (index !== -1 && (!this.hasConverted || isSalesLost && (this.canEditDistributor)) && statusAllowsAdd && (this.canAddProposal || this.commonService?.getUSER()?.canActAsSalesRep)) {
      this.grid.toolbar.splice(index + 1, 0, { id: 'add', align: 'Left', prefixIcon: 'fas fa-add', cssClass: '', tooltipText: 'Add' });
    }
  }

  getRolePermission() {
    // this.commonService.getRolePermission('proposal','proposalGrid','proposal').subscribe((res: any) => {
    //   res.result.forEach((rule: any) => {
    //     this.rolePermissions[rule.ruleAction] = {
    //         visible: rule.visible,
    //         readOnly: rule.readOnly,
    //         enable: rule.enable,
    //     }
    // });
    // // this.setToolbar()
    // }, (error: HttpErrorResponse) => {
    //   throw error;
    // });
  }

  onToolbarClick(args: any ) {
    if (args.item.id === 'add') {
      let canAdd = false;
      if (this.opportunityForm && this.opportunityForm.get('salesProcess')) {
        const salesProcess = this.opportunityForm.get('salesProcess').value || [];
        const needsAssessment = salesProcess.find((a: any) => a.title && a.title.toLowerCase() === 'needs assessment' && !a.isDeleted);
        if (needsAssessment) {
          const children = salesProcess.filter((a: any) => a.parentId === needsAssessment.id && !a.isDeleted);
          if (children.length > 0) {
            const isAnyCompleted = children.some((c: any) => c.statusValue === 'saleProcCompleted');
            if (isAnyCompleted) {
              canAdd = true;
            }
          }
        }
      }

      if (!canAdd) {
        this.commonService.showNotification('warning', 'Please complete at least one Needs Assessment task before creating a proposal.');
        return;
      }
      if (this.hasNeedsAssessmentChangedSinceOpen()) {
        this.commonService.showNotification(
          'warning',
          'Please save the opportunity first before proceeding to proposal creation.'
        );
        return;
      }
      if (this.opportunityForm.get('salesTypeValue').value == 'direct') {
        if (this.dataSource.some(item => item.isActive === true)) {
          this.commonService.showConfirmation("Creating a new proposal will mark your existing active proposal as inactive. Are you sure you want to proceed?")
            .then(result => {
              if (result.isConfirmed) {
                this.openProductCatalogPopup()
              }
          });
        } else {
          this.openProductCatalogPopup()
        }
      } else {
        // Indirect: proposal tab + → product catalog (Channel & Account from distributor, read-only).
        // Proposal / Sales Lost: always pick a distributor first, then open the catalog.
        const status = this.opportunityForm.get('statusValue')?.value;
        const isSalesLost = status === 'oppSaleLost' || status === 'oppSalesLost';
        const hasDistributor = this.opportunityForm.get('opportunityLastQuotedModel')?.value?.[0]?.accountId;
        if (hasDistributor && status !== 'oppProposal' && !isSalesLost) {
          this.openProductCatalogPopup(false)
        } else {
          this.openDistributorPopupFromProposal.emit()
        }
      }
    } else if (args.item.id === 'clear-filter') {
      this.grid.clearFiltering();
      this.grid.search('');
    }  else if (args.item.id === 'refresh') {
      this.grid.refresh();
    }
  }

  openProductCatalogPopup(readOnly = false): void {
    // this.openProposalPopup()
    // return
      const dialogRef = this.dialog.open(ProductCatalogPopupComponent, {
          backdropClass: 'no-backdrop',
          disableClose: true,
          maxWidth: '100vw',
          maxHeight: '100vh',
          width: '100%',
          height: '100%',
          enterAnimationDuration: '0',
          exitAnimationDuration: '0',
          data: {
            title: 'Product Catalog',
            isMaximized: true,
            item: {
              channel: this.opportunityForm.get('opportunityLastQuotedModel')?.value[0]?.channelValue,
              account: this.opportunityForm.get('opportunityLastQuotedModel')?.value[0]?.accountValue,
              cart: [],
              currency: this.opportunityForm.get('currency')?.value,
              readonly: readOnly,
              fromProposal: true,
            }
          }
      });
      dialogRef.afterClosed().subscribe(result => {
        const isInstallRequired = result.some(obj => obj.isInstallRequired === true);
        const items = result.filter(obj => obj.itemType !== 'Package');
        const packages = result.filter(obj => obj.itemType === 'Package');

        const generateUniqueTempId = () => Number(`999${Math.floor(100000 + Math.random() * 900000)}`);

        if (items) {
          items.forEach(item => {
            item.id = generateUniqueTempId();
            item.isDeleted = false;
            item.tradeIn = 0;
            item.discountPercentage = 0;
            item.tempId = generateUniqueTempId();

            if (item.itemsList) {
              item.itemsList.forEach(subItem => {
                subItem.id = generateUniqueTempId();
                subItem.isDeleted = false;
                subItem.tradeIn = 0;
                subItem.discountPercentage = 0;
                subItem.tempId = generateUniqueTempId();
              });
            }
          });
        }

        if (packages) {
          packages.forEach(item => {
            item.id = generateUniqueTempId();
            item.isDeleted = false;
            item.tradeIn = 0;
            item.discountPercentage = 0;
            item.tempId = generateUniqueTempId();

            if (item.itemsList) {
              item.itemsList.forEach(subItem => {
                subItem.id = generateUniqueTempId();
                subItem.quantity = subItem.quantity ?? 1;
                subItem.isDeleted = false;
                subItem.tradeIn = 0;
                subItem.discountPercentage = 0;
                subItem.tempId = generateUniqueTempId();
              });
            }
          });
        }

        console.log('items grid: ', items);
        console.log('packages grid: ', packages);
        this.openProposalPopup(items, packages, null, isInstallRequired);
      });

    }

    openOnHoldPopup(proposalId) {
      const dialogRef = this.dialog.open(OnholdDetailsPopupComponent, {
          backdropClass: 'no-backdrop',
          disableClose: true,
          maxWidth: '100vw',
          maxHeight: '100vh',
          width: '30%',
          height: '50%',
          enterAnimationDuration: '0',
          exitAnimationDuration: '0',
          data: {
            proposalId: proposalId,
          }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.loadData()
      });
    }

    openProposalPopup(items?, packages?, proposalId?, isInstallRequired = false, tab: string = tabsModel.details): void {
      const dialogRef = this.dialog.open(ProposalPopupComponent, {
          backdropClass: 'no-backdrop',
          disableClose: true,
          maxWidth: '100vw',
          maxHeight: '100vh',
          width: '100%',
          height: '100%',
          enterAnimationDuration: '0',
          exitAnimationDuration: '0',
          data: {
            salesType: this.opportunityForm.get('salesTypeValue').value,
            accountValue: this.opportunityForm.get('opportunityLastQuotedModel')?.value[0]?.accountValue,
            accountName: this.opportunityForm.get('opportunityLastQuotedModel')?.value[0]?.accountName,
            accountId: this.opportunityForm.get('opportunityLastQuotedModel')?.value[0]?.accountId,
            channelValue: this.opportunityForm.get('opportunityLastQuotedModel')?.value[0]?.channelValue,
            channelName: this.opportunityForm.get('opportunityLastQuotedModel')?.value[0]?.channelName,
            financingTypeValue: this.opportunityForm.get('financingTypeValue')?.value,
            opportunityForm: this.opportunityForm,
            id: proposalId,
            items: items,
            packages: packages,
            isInstallRequired: isInstallRequired,
            bpId: this.opportunityForm.get('bpId')?.value,
            bpCity: this.opportunityForm.get('bpCity')?.value,
            bpState: this.opportunityForm.get('bpState')?.value,
            bpZipCode: this.opportunityForm.get('bpZipCode')?.value,
            tab
          }
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result?.resetProposalPopup) {
          this.openProposalPopup(items, packages, proposalId, isInstallRequired, tab);
        } else {
          this.loadData()
          this.refreshOpportunity.emit()
        }
      });
    }

  openOpportunityPopup(id: string = null) {
    // const dialog = this.dialog.open(OpportunitiesPopupComponent, {
    //   backdropClass: 'no-backdrop',
    //   disableClose: true,
    //   maxWidth: '100vw',
    //   maxHeight: '100vh',
    //   width: '100%',
    //   height: '100%',
    //   enterAnimationDuration: '0',
    //   exitAnimationDuration: '0',
    //   autoFocus: false,
    //   data: {
    //     id: id,
    //     isMaximized: true,
    //     type: 'indirect'
    //   }
    // });
    // dialog.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.grid.refresh()
    //   }
    // });
  }

  openSalesOrderPopup(salesOrderId:any) {
    const dialogRef = this.dialog.open(SalesOrderPopupComponent, {
        backdropClass: 'no-backdrop',
        disableClose: true,
        maxWidth: '100vw',
        maxHeight: '100vh',
        width: '100%',
        height: '100%',
        enterAnimationDuration: '0',
        exitAnimationDuration: '0',
        data: {
          title: '',
          tab: tabsModel.details,
          isMaximized: true,
          id: salesOrderId,
        }
    });
    dialogRef.afterClosed().subscribe(result => { });
  }
  updateStatus(data: any) {
    const request = {
      proposalId: data.proposalId,
      statusValue: data.statusValue,
    };

    this.proposalService.updateProposalStatus(request)
      .subscribe({
        next: (res: any) => {
          this.refreshOpportunity.emit();
        },
        error: (error) => this.commonService.showNotification("error", error.error.message)
      });
  }

  activateProposal(proposalId) {
    this.proposalService.activateProposal(proposalId)
      .subscribe({
        next: (response) => {
          this.loadData();
          this.refreshOpportunity.emit();
        },
        error: (error) => this.commonService.showNotification("error", error.error.message)
      });
  }

  openRevisionDetailsPopup(id) {
    const popup = this.dialog.open(RevisionDetailsPopupComponent, {
        backdropClass: 'no-backdrop',
        disableClose: true,
        maxWidth: '100vw',
        maxHeight: '100vh',
        width: '30%',
        height: '50%',
        enterAnimationDuration: '0',
        exitAnimationDuration: '0',
        data: {
            proposalId: id,
            fromOpportuinity: true
        }
    });
    popup.afterClosed().subscribe(result => {
        if (result) {
            this.loadData()
        }
    });
  }

  commandClick(args: any, grid) {
    switch (args.commandColumn.title) {
      case 'Revise':
        this.commonService.showConfirmation("Are you sure you want to revise this proposal?")
          .then(result => {
            if (result.isConfirmed) {
                this.openRevisionDetailsPopup(args.rowData.proposalId);
              }
            });
        break;
      case 'Approve':
        this.commonService.showConfirmation("Are you sure you want to approve this proposal?")
          .then(result => {
            if (result.isConfirmed) {
               this.proposalService.checkShowstoppersById(args.rowData.proposalId).subscribe({
                    next: (response: any) => {
                        if(response.result) {
                            this.commonService.showNotification('error',"This proposal contains showstoppers! You must resolve the showstoppers first before proceeding!")
                        } else {
                            this.proposalService.checkShowstoppersAndWarnings(args.rowData.proposalId).subscribe({
                                next: (response: any) => {
                                    this.showLoader = false;

                                    if (response.result?.itemShowstopper || response.result?.packageShowstopper) {
                                        this.commonService.showNotification('warning', 'You must resolve the showstoppers first before proceeding!');
                                        return;
                                    }

                                    if (response.result?.emptyItemShowstopper) {
                                        this.commonService.showNotification('warning', 'Please add at least one item or package to continue!');
                                        return;
                                    }

                                // 🔵 Step 1: Installer confirmation
                                const handleInstallerCheck = () => {
                                    if (response.result?.installerWarning) {
                                        return this.commonService.showConfirmation(
                                            "Your proposal contains items that might require installation, but you have not selected an installer.",
                                            "Yes", "No", "Are you sure you want to proceed with self-installation"
                                        );
                                    }
                                    return Promise.resolve({ isConfirmed: true });
                                };

                                // 🔵 Step 2: Shipping confirmation
                                const handleShippingCheck = () => {
                                    if (response.result?.shippingWarning) {
                                    return this.commonService.showConfirmation(
                                        'Shipping charges are 0. Are you sure you want to proceed with 0 shipping charges?',
                                        'Yes', 'No', 'Do you want to proceed?'
                                    );
                                    }
                                    return Promise.resolve({ isConfirmed: true });
                                };

                                // 🔵 Step 3: Items confirmation
                                const handleItemsCheck = () => {
                                  if (response.result?.shippingWarning) {
                                    return this.commonService.showConfirmation("Freight Discount has been applied.\n Some items will be flagged and require manager's approval if proposal is approved by the customer.", "Yes", "No", "Do you want to proceed?")
                                  }
                                  return Promise.resolve({ isConfirmed: true });
                                };

                                // 🔵 Chain execution properly
                                handleInstallerCheck()
                                    .then(result => {
                                        if (!result.isConfirmed) {
                                            return Promise.reject(); //  stop flow
                                        }
                                        return handleShippingCheck();
                                    })
                                    .then(shippingResult => {
                                      if (!shippingResult.isConfirmed) {
                                        return Promise.reject(); //  stop flow
                                      }
                                      return handleItemsCheck();
                                    })
                                    .then(itemsResult => {
                                      if (!itemsResult.isConfirmed) {
                                        return;
                                      }

                                      // ✅ Final step only runs if all confirmations passed
                                      if (response.result?.taxWarning) {
                                          this.commonService.showConfirmation('No tax is entered for this customer. Proceeding will set tax to 0.00', 'Yes', 'No', 'Do you want to proceed?')
                                          .then(result => {
                                              if (result.isConfirmed) {
                                              this.commonService.showConfirmation(`Net Amount is less than EDLP/PROMO.<br>These lines will be flagged and require managers approval if proposal is approved by the customer.`, "Yes", "No", "Do you want to proceed?")
                                              .then(result => {
                                                  if (!result.isConfirmed) {
                                                      return;
                                                  }
                                                  else {
                                                      this.openDocFilesPopup(args.rowData);
                                                  }
                                              });
                                              }
                                          })
                                      } else {
                                          this.openDocFilesPopup(args.rowData);
                                      }
                                      this.showLoader = false;
                                  })
                                  .catch(() => {
                                  // Flow intentionally stopped
                                  });
                                    
                                },
                                error: (error: any) => {
                                    this.showLoader = false;
                                    this.commonService.showNotification('error',"This proposal contains showstoppers! You must resolve the showstoppers first before proceeding!");
                                }
                            });
                        }
                    },
                    error: (error: any) => {
                        this.showLoader = false
                    }
                });
            }
          });
        break;
      case 'Reject':
        // Handle Reject action
        this.commonService.showConfirmation("Are you sure you want to reject this proposal?")
          .then(result => {
            if (result.isConfirmed) {
               this.updateStatus({
                proposalId: args.rowData.proposalId,
                statusValue: 'propRejected',
              });
            }
          });
        break;
      case 'Print proposal':
        // Handle Print proposal action
        // this.printProposal(args.rowData.proposalId);
        break;
      case 'Mark active':
        // Handle Mark active action
        if (!args.rowData.canActive) return;
        this.commonService.showConfirmation("Marking this proposal as active will mark your existing active proposal as inactive. Are you sure you want to proceed?","Yes","No")
          .then(result => {
            if (result.isConfirmed) {
              this.activateProposal(args.rowData.proposalId)
            }
          });
        break;
      case 'Convert':
        // Handle Convert action
        if(args.rowData.statusValue === 'propConverted') {
          this.openSalesOrderPopup(args.rowData.salesOrderId);
        } else {
            this.commonService.showConfirmation("Are you sure you want to convert this proposal?")
              .then(result => {
                if (result.isConfirmed) {
                    this.showLoader = true;
                    this.opportunitiesService.getOpportunityById(args.rowData.opportunityId).subscribe({
                      next: (oppRes: any) => {
                        const activities = oppRes?.result?.salesProcess || [];
                        const allCompleted = activities.every(a => a.isDeleted || a.statusValue === 'saleProcCompleted');
                        
                        if (!allCompleted) {
                          this.showLoader = false;
                          this.commonService.showNotification('warning', 'All activities in the corresponding Opportunity’s Sales Process Plan must be completed before converting / transferring this proposal. Please complete the pending activities to proceed.');
                          return;
                        }

                        this.proposalService.checkShowstoppersById(args.rowData.proposalId).subscribe({
                          next: (response: any) => {
                            if(response.result) {
                                this.showLoader = false;
                                this.commonService.showNotification('error',"This proposal contains showstoppers! You must resolve the showstoppers first before proceeding!")
                            } else {
                              this.checkShowstoppersBeforeConverting(args);
                            }
                          },
                          error: (error: any) => {
                            this.showLoader = false
                          }
                        });
                      },
                      error: (err) => {
                        this.showLoader = false;
                        this.commonService.showNotification('error', 'Error while checking activities completion.');
                      }
                    });
                }
              });
        }
        break;
      case 'On Hold':
            this.openOnHoldPopup(args.rowData.proposalId);
        break;
      case 'Attachments':
        this.openProposalPopup(null, null, args.rowData.proposalId, false, tabsModel.attachments);
        break;
      case 'Comments':
        this.sharedService.globalComments = {
          grid, module: ModuleNames.Proposal, moduleId: args.rowData.proposalId, showComments: true
        }
        this.sharedService.globalComments.refreshLocalData = new Subject();
        this.sharedService.globalComments.refreshLocalData.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
          res && this.loadData();
        })
        break;
      case 'History':
        this.openProposalPopup(null, null, args.rowData.proposalId, false, tabsModel.history);
        break;
      case 'Links':
        this.openProposalPopup(null, null, args.rowData.proposalId, false, tabsModel.links);
        break;
      default:
        console.log('Unknown command:', args.commandColumn.title);
    }
  }

  checkShowstoppersBeforeConverting(args: any) {
    this.proposalService.checkShowstoppersAndWarnings(args.rowData.proposalId).subscribe({
      next: (response: any) => {
        this.showLoader = false;
        if (response.result?.financeShowstopper) {
            this.commonService.showNotification('error',"This proposal contains incomplete finance details!");
            return;
        }

        if (response.result?.itemShowstopper || response.result?.packageShowstopper) {
            this.commonService.showNotification('warning', 'You must resolve the showstoppers first before proceeding!');
            return;
        }

        if (response.result?.emptyItemShowstopper) {
            this.commonService.showNotification('warning', 'Please add at least one item or package to continue!');
            return;
        }
        this.proposalService.createSalesOrderFromProposal(args.rowData.proposalId).subscribe({
          next: (res: any) => {
              this.showLoader = false;
              this.updateStatus({
                  proposalId: args.rowData.proposalId,
                  statusValue: 'propConverted',
              });
              this.openSalesOrderPopup(res?.result?.salesOrderId);
              },
          error: (error: any) => {
              this.showLoader = false
          }
        });
        this.showLoader = false;
      },
      error: (error: any) => {
        this.showLoader = false;
        this.commonService.showNotification('error',"This proposal contains showstoppers! You must resolve the showstoppers first before proceeding!");
        return;
      }
    });
  }

  openDocFilesPopup(data:any) {
    const dialogRef = this.dialog.open(DocFilesPopupComponent, {
        backdropClass: 'no-backdrop',
        disableClose: true,
        maxWidth: '100vw',
        maxHeight: '100vh',
        width: '100%',
        height: '100%',
        enterAnimationDuration: '0',
        exitAnimationDuration: '0',
        data: {
            docsFileData: [],
            country: data.countryId,
            module: ModuleNames.Proposal,
            primaryId: data.proposalId,
            isMaximized: true,
            salesType: data.salesType ? (data.salesType as string).toLowerCase() : '',
            type: 'proposal',
            beingApprovedInOpenStatus: data.statusValue === 'propOpen',
            salesRepId: data.salesRepId,
            status: data.statusValue,
            isReadonly: false,
            showExistingDocs: false,
            customerData: {
                name: data.customerId,
                email: data.customerEmail
            }
        },
    })
    dialogRef.afterClosed().subscribe((result) => {
        if(result) {
            this.updateStatus({
                proposalId: data.proposalId,
                statusValue: 'propApproved',
            });
        }
    });
  }

  onGridActionComplete(args: any, grid: any) {
    updateFilterIcon(args, grid);
    if(!args.columnName && !args.direction && args.requestType === "sorting") {
        grid.sortColumn('isActive','Descending', false);
    }
  }

  created() {
    this.setToolbar()
  }

  onRowDataBound(args: any) {
    const data = args.data;
    const $row = args.row;

    const markActiveBtn = ($row.querySelector('.markActive-item') || $row.querySelector('[title="Mark active"]')) as HTMLElement;
    if (markActiveBtn) {
        if (data.canActive) {
            markActiveBtn.classList.remove('disabled');
            markActiveBtn.style.pointerEvents = 'auto';
            markActiveBtn.style.cursor = 'pointer';
        } else {
            markActiveBtn.classList.add('disabled');
            markActiveBtn.style.pointerEvents = 'none';
            markActiveBtn.style.cursor = 'default';
        }

        if (data.isActive) {
            const color = data.isActiveColor || 'green';
            markActiveBtn.style.setProperty('color', color, 'important');
            markActiveBtn.style.setProperty('opacity', '1', 'important');

            const icon = markActiveBtn.querySelector('.fas');
            if (icon) {
                (icon as HTMLElement).style.setProperty('color', color, 'important');
            }
        }
    }
    if (data.attColorCode) {
       const element = $row.getElementsByClassName('attachments-items')[0];
      if (element) {
        element.style.color = data.attColorCode;
      }
    }
    if (data.linkColorCode) {
      const element = $row.getElementsByClassName('linked-items')[0]
      if (element) {
        element.style.color = data.linkColorCode;
      }
    }
    if (data.commentColor) {
      const element = $row.getElementsByClassName('comments-items')[0]
      if (element) {
        element.style.color = data.commentColor;
      }
    }
    if (data.mappedColorCode) {
      const element = $row.getElementsByClassName('map-business-partner-item')[0]
      if (element) {
        element.style.color = data.mappedColorCode;
      }
    }
    if (data.canApprove && data.isActive) {
      $row?.getElementsByClassName('approve-item')[0]?.classList.remove('disabled');
      $row?.getElementsByClassName('approve-item')[0]?.classList.add('green-icon');

    } else {
      $row?.getElementsByClassName('approve-item')[0]?.classList.remove('green-icon');
      $row?.getElementsByClassName('approve-item')[0]?.classList.add('disabled');
    }

    if (data.canConvert) {
      $row?.getElementsByClassName('convert-item')[0]?.classList.remove('disabled');
      if(data.statusValue === "propConverted"){
        $row?.getElementsByClassName('convert-item')[0]?.classList.add('green-icon');
      }
    } else {
      $row?.getElementsByClassName('convert-item')[0]?.classList.add('disabled');
    }

    if (data.canOnHold) {
      $row?.getElementsByClassName('onHold-item')[0]?.classList.remove('disabled');
    } else {
      $row?.getElementsByClassName('onHold-item')[0]?.classList.add('disabled');
    }

    if (data.canReject) {
      $row?.getElementsByClassName('reject-item')[0]?.classList.remove('disabled');
      $row?.getElementsByClassName('reject-item')[0]?.classList.add('red-icon');
    } else {
        $row?.getElementsByClassName('reject-item')[0]?.classList.add('disabled');
        $row?.getElementsByClassName('reject-item')[0]?.classList.remove('red-icon');
    }

    if ((data.canRevise || data.statusValue === 'propApproved' || data.statusValue === 'propSigned') && data.isActive) {
      $row?.getElementsByClassName('revise-item')[0]?.classList.remove('disabled');
    } else {
      $row?.getElementsByClassName('revise-item')[0]?.classList.add('disabled');
    }
  }

  getStatusClass(status: string) {
    return this.commonService.getStatusClass(status);
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}
